<template>
  <div
    class="country-select"
  >
    <div class="country-container-main">
      <div class="country-language-title">
        Country/Region*
      </div>
      <div class="custom-select">
        <img
          :src="currentCountry.countryUrl"
          alt=""
        >
        <div class="input-wrapper">
          <input
            v-model="searchText"
            @focus="openDropdown"
            @blur="handleBlur"
            @input="handleInput"
          >
          <span
            v-if="showBackgroundHint"
            class="background-text"
          >
            {{ lastValue }}
          </span>
        </div>
        <Icon
          v-if="!isDropdownOpen"
          name="arrow-down-l-2"
        />
        <Icon
          v-else
          name="search-l"
          style="font-size: 20px;"
        />
        <Transition name="dropdown-fade">
          <div
            v-if="isDropdownOpen"
            class="dropdown"
          >
            <div
              v-for="option in filteredCountryList"
              :key="option.countryName"
              @click="selectOption(option)"
              class="dropdown-item"
            >
              <img
                :src="option?.countryUrl"
                alt=""
                class="dropdown-item-img"
              >
              <div>{{ option.countryName }}</div>
            </div>
          </div>
        </Transition>
      </div>
      <div
        class="country-language-title"
        style="margin-top: 12px;"
      >
        Post Code
      </div>
      <div class="custom-select">
        <input
          @input="handlePostcodeInput"
          v-model="postCode"
          placeholder="Post Code"
          maxlength="20"
        >
      </div>
      <div
        class="country-confirm"
        @click="saveCountry"
      >
        Save
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import Icon from '@/components/Icon/Icon.vue'
import { useCountryStore } from '@/pinia/country'
import { useShipStore } from '@/pinia/ship'

const props = defineProps({
  currentCountry: {
    type: Object,
    default: () => {}
  }
})

const isDropdownOpen = ref(false)

const currentCountry = ref(props.currentCountry)

const postCode = ref()

const showBackgroundHint = ref(false)

const lastValue = ref('')

const searchText = ref('')

const country = useCountryStore()
const countryList = computed(() => country.list)

const ship = useShipStore()

const filteredCountryList = ref(countryList.value)

const handleInput = (e) => {
  showBackgroundHint.value = ''
  filteredCountryList.value = countryList.value.filter(v =>
    v.countryName.toLowerCase().includes(e.target.value.toLowerCase())
  )
}

const openDropdown = () => {
  if (searchText.value) {
    lastValue.value = searchText.value
    searchText.value = ''
    showBackgroundHint.value = true
  }
  filteredCountryList.value = countryList.value
  isDropdownOpen.value = true
}

const handleBlur = () => {
  searchText.value = lastValue.value
  lastValue.value = ''
  showBackgroundHint.value = false
  isDropdownOpen.value = false
}

const closeDropdown = () => {
  setTimeout(() => {
    isDropdownOpen.value = false
  }, 200)
}

const selectOption = (option) => {
  currentCountry.value = option

  searchText.value = option.countryName
  showBackgroundHint.value = false
  lastValue.value = ''
  closeDropdown()
}

const handlePostcodeInput = (e) => {
  postCode.value = e.target.value.replace(/[^A-Z0-9\- ]/gi, '')
}

const saveCountry = async (event) => {
  ship.update({
    country: currentCountry.value,
    postCode: postCode.value
  })

  document.dispatchEvent(new Event('click'), { bubbles: true })
}

onMounted(() => {
  searchText.value = props.currentCountry.countryName
  postCode.value = ship.postCode
})

</script>

<style lang="less" scoped>
.country-select {
  padding: 16px;
  .country-container-main {
    .country-language-title {
      font-family: mon-600;
      font-size: 12px;
      color: #232323;
      line-height: 16px;
    }

    .custom-select {
      position: relative;
      display: flex;
      align-items: center;
      gap: 4px;
      width: 100%;
      height: 34px;
      margin-top: 8px;
      border: 1px solid #ebf1f5;
      border-radius: 4px;
      padding: 0 8px;
      img {
        width: 20px;
        margin-right: 2px;
      }

      &:hover {
        border: 1.5px solid #232323;
      }

      input {
        &::placeholder {
          color: #b2b7c2;
        }
      }
    }

    .input-wrapper {
      position: relative;
      width: 100%;
      height: 16px;
      display: flex;
      align-items: center;
      .background-text {
        position: absolute;
        display: flex;
        align-items: center;
        color: #b2b7c2;
        pointer-events: none;
        font-size: 11px;
        user-select: none;
        font-family: mon-500;
      }
    }

    input {
      width: 100%;
      font-size: 11px;
      color: #232323;
      font-family: mon-500;
      border: none;
      outline: none;
    }

    .dropdown {
      position: absolute;
      top: 40px;
      left: 0;
      right: 0;
      border: 1px solid #ebf1f5;
      background-color: white;
      max-height: 200px;
      overflow-y: auto;
      border-radius: 4px;
      z-index: 10;
      padding: 4px;
      min-height: 20px;
    }

    .dropdown-item {
      display: flex;
      align-items: center;
      padding: 0 12px;
      height: 34px;
      cursor: pointer;
      font-family: mon-500;
      font-size: 11px;
      line-height: 16px;
      color: #232323;
      font-family: mon-500;

      .dropdown-item-img {
        position: relative;
        width: 20px;
        height: auto;
        margin-right: 6px;
      }
    }

    .dropdown-item:not(:first-child) {
      margin-top: 4px;
    }

    .dropdown-item:hover {
      background-color: #f8f8f8;
      border-radius: 4px;
      font-family: mon-600;
      color: #232323;
    }

    /* 定义动画 */
    .dropdown-fade-enter-active,
    .dropdown-fade-leave-active {
      transition: opacity 0.3s ease, transform 0.3s ease;
    }

    .dropdown-fade-enter,
    .dropdown-fade-leave-to {
      opacity: 0;
      transform: translateY(-10px);
      /* 设置一个轻微的上移 */
    }
  }

  .country-item {
    width: 120px;
    background-color: #ffffff;
  }

  .country-confirm {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 32px;
    margin-top: 12px;
    font-family: mon-600;
    font-size: 12px;
    color: #FFFFFF;
    background-color: #052784;
    border-radius: 16px;
    cursor: pointer;
    transition: all 0.3s;
  }
}
</style>
